import React from "react";
import "../Navigation/css/NavBar.scss";
import {Black} from "../../theme/styles";
import lotEnterpriseObject from "../../assets/lotEnterpriseObject.png";
import lotRevisionEnterpriseObject from "../../assets/lotRevisionEnterpriseObject.png";

export default function Lots() {

    return (
        <div style={{paddingLeft: "20px", paddingRight: "30px"}}>
            <p style={{fontSize: "24px", fontWeight: "400", color: Black}}>Lots</p>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>REST APIs support the handling of lots in Enlil.</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>In Enlil, lots are documents whose document type group attribute is set to "LOT". This family of APIs allows for the retrieval, creation and updating of lots.</li>
            </ul>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>The Enterprise Object Model for Lots is detailed below. Other Enlil entities (Equipment, Material, etc.) have a similar Enterprise Object Model.</p>
            <br/>
            <img src={lotEnterpriseObject} alt={"Model"}/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>The Enterprise Object Model for Lot Revisions is detailed below. Other Enlil entities (Equipment Revision, Supplier Revision, etc.) have a similar Enterprise Object Model.</p>
            <br/>
            <img src={lotRevisionEnterpriseObject} alt={"Model"}/>
        </div>
    )
}